import { api } from "@/api/axios.ts";
import { ApiAppConfig, ApiMenuCounters } from "@/types/config.types.ts";

export const appApi = {
  getConfig: async () => {
    return api.get<ApiAppConfig>(`/api/v1/app/config`);
  },
  getMenuCounters: async () => {
    return api.get<ApiMenuCounters>(`/api/v1/counters/menu`);
  },
};
